import './index.scss'

$('header .pc-header .header .right-cont .nav ul li .sub-nav.solution .nav-solution-icon a').on('click',function(){
  let parentsLi = $(this).parents('li')
  parentsLi.removeClass('show-sub on').find('.sub-nav').slideUp()
  $('header .mask').fadeOut()
  $('.pc-header').removeClass('active')
  
  setTimeout(function(){
    setpage()
  },200)
})

$(document).ready(function(){
  setpage()
  listset()
})

function setpage(){
  if(window.location.href.split('#').length > 1){
    let page = window.location.href.split('#')[1]
    let index = page.split('e')[1]
    $("html, body").animate({
      scrollTop: $('#page'+index).offset().top - $('.header').height() - 50 + "px"
    }, {duration: 0});
  }
}

// if($(window).width() < 768){
//   $('.solution-page .solution-li .solution-tab-list li').removeClass('wow fadeInUp')
//   $('.solution-page .solution-li').eq(0).addClass('active').find('.solution-tab-list').slideDown()
//   $('.solution-page .solution-li .solution-list-title').on('click',function(){
//     let $parents = $(this).closest('.solution-li')
//     if($parents.hasClass('active')){
//       $parents.removeClass('active').find('.solution-tab-list').slideUp()
//     }else{
//       $parents.addClass('active').find('.solution-tab-list').slideDown()
//       $parents.siblings().removeClass('active').find('.solution-tab-list').slideUp()
//     }
//   })
// }
// $(window).resize(function(){
//   listset()
// })

function listset(){
  if($(window).width() < 768){
    $('.solution-page .solution-li').find('.solution-tab-list').hide()
    $('.solution-page .solution-li .solution-tab-list li').removeClass('wow fadeInUp')
    $('.solution-page .solution-li').eq(0).addClass('active').find('.solution-tab-list').slideDown()
    $('.solution-page .solution-li .solution-list-title').on('click', function(){
      let $parents = $(this).closest('.solution-li')
      if($parents.hasClass('active')){
        $parents.removeClass('active').find('.solution-tab-list').slideUp()
      }else{
        $parents.addClass('active').find('.solution-tab-list').slideDown()
        $parents.siblings().removeClass('active').find('.solution-tab-list').slideUp()
      }
    })
  }else{
    $('.solution-page .solution-li .solution-tab-list li').addClass('wow fadeInUp')
    $('.solution-page .solution-li').removeClass('active').find('.solution-tab-list').show().css('display','flex')
  }
}
